<template>
  <ul class="calendar-legend">
    <li class="calendar-legend__item" v-for="item in legendItems" :key="item.id">
      <VesCalendarIndicator class="calendar-legend__indicator" :id="item.id" />
      <span class="calendar-legend__text">{{ item.text }}</span>
    </li>
  </ul>
</template>

<script>
  import { CALENDAR_LEGEND_ORDER, CALENDAR_LEGEND_TEXT } from '../../../constants/constants.js';
  import VesCalendarIndicator from './VesCalendarIndicator.vue';

  export default {
    name: 'VesCalendarLegend',

    components: {
      VesCalendarIndicator,
    },

    computed: {
      legendItems() {
        return CALENDAR_LEGEND_ORDER.map((id) => ({
          id,
          text: CALENDAR_LEGEND_TEXT[id],
        }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .calendar-legend {
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    column-gap: 24px;
    row-gap: 16px;
  }

  .calendar-legend__item {
    flex: 0 1 auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .calendar-legend__indicator {
    flex: 0 0 auto;
  }

  .calendar-legend__text {
    font: $fira-14;
  }
</style>
